import { Checkbox, Divider, Grid, makeStyles, Radio } from "@material-ui/core";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { useCardBrand, images } from "react-card-brand";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import AC from "../redux/actions/actionCreater";
import VCERNModal from "./elements/VCERNModal";
import VCERNTypography from "./elements/VCERNTypography";
import VCERNButton from "./elements/VCERNButton";
const useStyles = makeStyles((theme) => ({
  boldText: { fontWeight: "bold" },

  divider: { margin: "15px 0" },
  inline: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cardBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  membershipText: {
    padding: 10,
    fontWeight: "bold",
    boxShadow: "0 0 5px #888888",
    borderRadius: 5,
  },
  remberMeContainer: { display: "flex", alignItems: "center", width: "100%" },
  underline: {
    fontWeight: "bold",
    margin: "20px 0",
    textDecoration: "underline",
    cursor: "pointer",
  },
  card: {
    borderBottom: "2px solid #07A7E3",
    paddingBottom: 5,
    margin: "20px 10px",
  },
}));
function PaymentModal({
  title,
  open,
  onClose,
  onConfirm,
  setError,
  userSubscriptionPrice,
  currentOrganization,
  invitation,
  fetchPaymentMethods,
  token,
  onReject,
}) {
  const { getSvgProps } = useCardBrand();
  const classes = useStyles();
  const history = useHistory();
  const stripe = useStripe();
  const elements = useElements();
  const [methods, setMethods] = useState([]);
  const [selectedCard, setSelectedCard] = useState(0);
  const [agreedTerms, setAgreedTerms] = useState(false);
  const handleGetMethods = () => {
    fetchPaymentMethods(token, (val) => {
      setMethods(val.options);
      setSelectedCard(val.options[0].id);
    });
  };
  useEffect(() => {
    handleGetMethods();

    // eslint-disable-next-line
  }, []);
  const handleSubmit = async (evt) => {
    if (!(selectedCard === 999)) return onConfirm(selectedCard);
    if (!agreedTerms)
      return setError("Please accept Terms & Conditions to proceed");
    evt.preventDefault();
    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      console.log("[error]", error);
      setError(error.message);
    } else {
      // register({ ...data, payment_method: paymentMethod.id }, type, () => history.push('/verify'));
      onConfirm();
    }
  };
  return (
    <VCERNModal
      title="New Pool"
      open={open}
      onClose={onClose}
      // buttonTittle={title}
    >
      <div className={classes.inline}>
        <VCERNTypography
          value={invitation?.pool?.name}
          className={classes.boldText}
          customColor="#657285"
        />
      </div>
      <Divider variant="fullWidth" className={classes.divider} />
      <VCERNTypography
        value="Summary"
        variant="h6"
        className={classes.boldText}
      />
      <VCERNTypography value={invitation?.pool?.description} variant="body2" />
      <Divider variant="fullWidth" className={classes.divider} />
      <VCERNTypography
        value="Select card"
        variant="h6"
        className={classes.boldText}
      />
      {methods.map((el, idx) => (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} className={classes.inline}>
            <Radio
              checked={el?.id === selectedCard}
              onChange={() => setSelectedCard(el?.id)}
            />
            <div className={classes.defaultButton}>
              <svg {...getSvgProps({ type: el.brand, images })} />
            </div>
            <div className={classes.defaultButton}>
              <VCERNTypography
                variant="body2"
                value={el?.brand}
                className={classes.boldText}
              />
            </div>
            <VCERNTypography
              variant="body2"
              value={`**** **** **** ${el?.last4}`}
              className={classes.boldText}
              customColor="#657285"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            direction="row"
            className={classes.cardBox}
          >
            <Checkbox
              color="secondary"
              value={agreedTerms}
              checked={agreedTerms}
              onChange={(evt) => setAgreedTerms(evt.target.checked)}
            />
            <VCERNTypography variant="body1" className={classes.text}>
              I agree with the terms set forth in this new pool
            </VCERNTypography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            className={classes.cardBox}
            direction="row-reverse"
          >
            <VCERNButton
              color="primary"
              disabled={!agreedTerms}
              onClick={handleSubmit}
              value={title}
            />
            {title == "Join" && (
              <VCERNButton
                color="primary"
                onClick={onReject}
                value={"Reject"}
              />
            )}
          </Grid>
        </Grid>
      ))}
    </VCERNModal>
  );
}
export default connect((state) => state, {
  setError: AC.setError,
  fetchPaymentMethods: AC.fetchPaymentMethods,
})(PaymentModal);
